import moment from "moment";
import 'moment/locale/pl';

export default function () {
    const liveStamps = document.querySelectorAll('[data-livestamp]');

    const setTimePassed = (ls) => {
        if (ls.getAttribute('data-livestamp') === '') return;

        const timestamp = +ls.getAttribute('data-livestamp') * 1000;

        ls.innerHTML = moment(timestamp).fromNow();
    }

    liveStamps.forEach((ls, index) => {
        setTimePassed(ls);

        setInterval(function () {
            setTimePassed(ls);
        }, 30000);
    });
}